module.exports = __webpack_public_path__ + "img/44.1d9d59da.png";